module.exports = __webpack_public_path__ + "static/media/Planet Legacy.c84f3131.jpg";